import { render } from "./IdentifyVerifyWarning.vue?vue&type=template&id=5940a910"
import script from "./IdentifyVerifyWarning.vue?vue&type=script&lang=js"
export * from "./IdentifyVerifyWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__